// extracted by mini-css-extract-plugin
export default {"cAlert":"Alert_cAlert__ieSQm"};